import {IssueClosedIcon, IssueDraftIcon, IssueOpenedIcon} from '@primer/octicons-react'

import type {DraftIssue, ExistingIssue} from '../content-preview-types'

type IssueIconProps = Pick<DraftIssue, 'type'> | Pick<ExistingIssue, 'type' | 'state'>

export function IssueIcon(props: IssueIconProps) {
  if (props.type === 'existing-issue') {
    if (props.state === 'open') {
      return <IssueOpenedIcon className="fgColor-open" />
    }
    if (props.state === 'closed') {
      return <IssueClosedIcon className="fgColor-done" />
    }
  }

  return <IssueDraftIcon className="fgColor-draft" />
}
